import React from 'react';
export default /*#__PURE__*/ React.createContext({});
